<template>
    <div class="register">
        <header-comp></header-comp>
        <div class="register-wrap">
            <img class="register-img" src="@/assets/img/flypig.svg" alt="">
            <h1>為您公司註冊企業帳號</h1>
            <div class="register-basic-info">
                <!-- <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            公司統一編號
                        </div>
                        <span v-show="error.register.companyId" class="error-with-title">{{error.register.companyId}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.register.companyId}" type="text" v-model="register.companyId" placeholder="請輸入公司統一編號">
                    </div>
                </div> -->
                <div>
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            電子郵件帳號
                        </div>
                        <span v-show="error.register.email" class="error-with-title">{{error.register.email}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.register.email}" type="text" v-model="register.email" placeholder="請輸入電子郵件帳號">
                    </div>
                </div>
                <div class="password">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            密碼
                        </div>
                        <span v-show="error.register.password" class="error-with-title">{{error.register.password}}</span>
                    </label>
                    <div class="input-arear">
                        <input ref="password" :class="{error: error.register.password}" type=password v-model="register.password" placeholder="需包含英文加上數字八位字元">
                        <div v-if="password.pwdShow" @click="togglePassword('pwd')" class="show-hide-pwd">
                            <span v-if="password.pwdVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
                <div class="password-check">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            確認密碼
                        </div>
                        <span v-show="error.register.passwordCheck" class="error-with-title">{{error.register.passwordCheck}}</span>
                    </label>
                    <div class="input-arear">
                        <input  ref="passwordCheck" :class="{error: error.register.passwordCheck}" type=password v-model="register.passwordCheck" placeholder="再次確認密碼">
                        <div v-if="password.pwdCheckShow" @click="togglePassword('pwdCheck')" class="show-hide-pwd">
                            <span v-if="password.pwdCheckVisible">
                                隱藏
                            </span>
                            <span v-else>
                                顯示
                            </span>
                        </div>
                    </div>
                </div>
                <div class="position">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            工作崗位
                        </div>
                        <span v-show="error.register.position" class="error-with-title">{{error.register.position}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select :class="{error: error.register.position}" refName="position" selectMsg="請選擇工作崗位" @getId="getSelectId"  bgColor="#fff" >
                            <ul>
                                <li v-for="(item, index) in positionList" :key="index" :data-id="index">{{item}}</li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
            </div>
            <div class="loading-wrap">
                <btn-loading v-if="status.isDisable"></btn-loading>
                <button class="default-button" :disabled="status.isDisable" @click="bizRegister()">成為企業會員</button>
            </div>
            <span class="private">註冊即同意 <router-link :to="{ name: 'privateAndPolicy'}">會員隱私條款</router-link></span>
        </div>
    </div>
</template>
<script>
import Header from '@/components/bussiness/header.vue';
import RentCheckbox from '@/components/widge/RentCheckbox.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import borderBtnRadio from '@/components/widge/borderBtnRadio.vue';
import DatePicker from 'vue2-datepicker';
import btnLoading from '@/components/bussiness/widges/btnLoading.vue';
import { mapGetters } from 'vuex'
import { 
    apiBizRegister
} from "@/apis/api.js";
export default {
    data () {
        return {
            register: {
                email: null,
                password: null,
                passwordCheck: null,
                // companyId: null,
                position: null
            },
            error: {
                register: {
                    email: null,
                    password: null,
                    passwordCheck: null,
                    // companyId: null,
                    position: null
                }
            },
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名',
                    selectedRoad: null
                }
            },
            password: {
                pwdShow: false,
                pwdVisible: false,
                pwdCheckShow: false,
                pwdCheckVisible: false,
            },
            status: {
                isDisable: false,
            },
            positionList: ['老闆', '技術人員', '營運人員', '業務',],
            cx:[1,2,1,2,1,2,4,1]
        }
    },
    watch: {
        register: {
            handler: function (val) {
                // console.log(val)
                // 帳號判斷
                let isMail = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
                if( val.email ){
                    if (!isMail.test(val.email)) {
                        this.error.register.email = '電子郵件格式錯誤';
                    }else {
                        this.error.register.email = null;
                    }
                }
                //密碼判斷
                let isText = /^(?=.*\d)(?=.*[a-zA-Z]).{8,30}$/;
                if( val.password ){
                    this.password.pwdShow = true
                    if (!isText.test(val.password)) {
                        this.error.register.password = '需包含英文加上數字八位字元';
                    }else {
                        this.error.register.password = null;
                    }
                }
                //密碼確認
                if( val.passwordCheck ){
                    this.password.pwdCheckShow = true
                    if(val.passwordCheck == val.password){
                        this.error.register.passwordCheck = null;
                    }else{
                        this.error.register.passwordCheck = '需與填寫密碼相同';
                    }
                }
                //公司統一編號
                // if( val.companyId ){
                //     this.chknum(val.companyId)
                // }
                //公司統一編號
                if( val.position ){
                    this.error.register.position = null;
                }
            },
            deep: true
        },
    },
    methods: {
        getSelectId: function (value) {
            // console.log(value)
            let targetId = event.target.dataset.id
            if ( value.ref == 'county' ){
                //區域及縣市變為預設
                this.address.district.state = true
                this.address.road.state = true
                this.address.district.msg = '區域'
                this.address.road.msg = '路段'
                this.register.district = null
                this.register.road = null
                this.register.city = targetId+1
                this.$store.dispatch('getDistrict',(parseInt(targetId)+1))
            }else if ( value.ref == 'district' ){
                this.address.road.state = true
                this.address.road.msg = '路段'
                this.address.district.state = false

                this.register.district = targetId
                this.$store.dispatch('getRoad',(parseInt(targetId)))
            }else if ( value.ref == 'road' ){
                this.address.road.state = false

                this.register.road = parseInt(targetId)
            }else if ( value.ref == 'position' ){
                this.register.position = this.positionList[targetId]
            }
        },
        togglePassword: function (type) {
            if(type == 'pwd'){
                let password = this.$refs.password;
                if (password.type === "password") {
                    this.password.pwdVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdVisible = false
                    password.type = "password";
                }
            }else{
                let password = this.$refs.passwordCheck;
                if (password.type === "password") {
                    this.password.pwdCheckVisible = true
                    password.type = "text";
                } else {
                    this.password.pwdCheckVisible = false
                    password.type = "password";
                }
            }
            
        },
        chknum: function (val) {
            let NO = val;
            let SUM = 0;
            if (NO.length != 8) {
                this.error.register.companyId = '公司統一編號格式錯誤'
                return;
            }
            let cnum = NO.split("");
            for (let i=0; i<=7; i++) {
                if (NO.charCodeAt() < 48 || NO.charCodeAt() > 57) {
                this.error.register.companyId = '公司統一編號格式錯誤'
                return;
                }
                SUM += this.cc(cnum[i] * this.cx[i]);
            }
            if (SUM % 10 == 0) {
                this.error.register.companyId = null
            }
            else if (cnum[6] == 7 && (SUM + 1) % 10 == 0){
                this.error.register.companyId = null
            }else {
                this.error.register.companyId = '公司統一編號格式錯誤'
            }
        },
        cc: function (n){
            if (n > 9) {
                let s = n + "";
                let n1 = s.substring(0,1) * 1;
                let n2 = s.substring(1,2) * 1;
                n = n1 + n2;
            }
            return n;
        },
        checkInput: function () {

            if(!this.register.email){
                this.error.register.email = '請輸入電子郵件帳號'
            }
            if(!this.register.password){
                this.error.register.password = '請輸入密碼'
            }
            if(!this.register.passwordCheck){
                this.error.register.passwordCheck = '請輸入確認密碼'
            }
            // if(!this.register.companyId){
            //     this.error.register.companyId = '請輸入公司統一編號'
            // }
            if(!this.register.position){
                this.error.register.position = '請選擇工作崗位'
            }
            if(
                this.register.email &&
                this.register.password &&
                this.register.passwordCheck &&
                // this.register.companyId &&
                this.register.position &&
                this.error.register.email == null &&
                this.error.register.password == null &&
                this.error.register.passwordCheck == null &&
                // this.error.register.companyId == null &&
                this.error.register.position == null
            ){
                return true
            }else{
                return false
            }
        },
        bizRegister: function () {
            let email = this.register.email
            let password = this.register.password
            // let companyId = this.register.companyId
            let position = this.register.position

            let data = {
                email,
                password,
                // companyId,
                position
            }

            if(this.checkInput()){
                this.status.isDisable = true
                this.$store.dispatch('bizRegister',data)
                .then(()=>{
                    this.status.isDisable = false
                    this.$router.push({ name: 'bizVerifiedEmail'})
                })
                .catch(err => {
                    this.status.isDisable = false
                    if(err.data.errorCode == 251011){
                        this.error.register.email = err.data.errorMsg
                    }else if(err.data.errorCode == 251012){
                        // this.error.register.companyId = err.data.errorMsg
                    }else{
                        let alarm = {
                            status: true,
                            title: '系統發生未預期錯誤，請再試一次',
                            description: null,
                            type: 'error'
                        }
                        this.$store.dispatch('setAlarmStatus', alarm)
                    }
                })
            }
            
        }
    },
    computed: {
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.address.road.selectedRoad ){
                    if(road.roadStreetName.includes(this.address.road.selectedRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
        })
    },
    components: {
        'header-comp': Header,
        RentCheckbox,
        RentSelect,
        DatePicker,
        borderBtnRadio,
        btnLoading
    }
}
</script>
<style lang="scss" scoped>
    .register{
        position: relative;
        margin-bottom: 70px;
        >.register-wrap{
            width: 424px;
            padding-top: 105px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
           
            input{
                box-sizing: border-box;
                width: 424px;
            }
            .register-img{
                width: 80px;
                margin-bottom: 20px;
            }
            h1{
                font-size: 24px;
                margin-bottom: 30px;
            }
            .register-basic-info{
                width: 100%;
                >div{
                    margin-bottom: 24px;
                    .show-hide-pwd{
                        position: absolute;
                        font-size: 12px;
                        top: 16px;
                        right: 16px;
                        cursor: pointer;
                    }
                }
            }
            .register-bussiness-info{
                width: 100%;
                h1{
                    border-bottom: solid 1px #f3f3f3;
                    padding-bottom: 18px;
                    margin-bottom: 23px;
                }
                >div{
                    margin-bottom: 24px;
                    .radio-btn-group{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .couty-group{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 8px;
                        .county,
                        .district{
                            width: 86px;
                        }
                        .road{
                            width: 140px;
                        }
                    }
                }
                .border-btn-radio{
                    width: 49%;
                }
                .mx-datepicker{
                    width: 100%;
                    input{
                        height: 46px;
                        width: 427px;
                        border-radius: 4px;
                        border: solid 1px #f3f3f3;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker.error{
                    input{
                        border: solid 1px #fc7171 !important;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    ::-webkit-input-placeholder { color: #676362; }
                    input::-moz-placeholder{
                        color:#676362;
                    }
                    input{
                        border: 1px solid #676362 ;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                span.error {
                    right: 0;
                    top: 3px;
                    left: unset;
                    bottom: unset;
                }
            }
            .loading-wrap{
                position: relative;
                width: 100%;
                .default-button{
                    width: 100%;
                    padding: 14px 0 14px 0;
                    
                }
                .btn-loading{
                    left: 134px;
                    top: 6px;
                }
            }
            
            .private{
                display: block;
                text-align: center;
                margin-top: 16px;
                margin-bottom: 6px;
                font-size: 12px;
                font-weight: 300;
                color: #676362;
                margin-bottom: 34px;
                a{
                    text-decoration: underline;
                }
            }
        }
    }
    @media screen and (max-width: 500px) {
        .register{
            position: relative;
            >.register-wrap{
                padding: 82px 4.8% 0 4.8%;
                width: 90.4%;
                input{
                    box-sizing: border-box;
                    width: 100%;
                }
                .register-bussiness-info{
                    >div{
                        .couty-group{
                            .county,
                            .district{
                                width: 19%;
                            }
                            .road{
                                width: 31.36%;
                            }
                        }
                    }
                    .mx-datepicker{
                        input{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/registerFlow/register.vue